export default [
  {
    path: 'login',
    name: 'login-view',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: {
      bypassAuth: true,
      renderNav: false,
      title: 'Login',
    },
  },
  {
    path: 'magic',
    name: 'magic',
    component: () => import('@/views/auth/MagicLink.vue'),
    meta: {
      bypassAuth: true,
      renderNav: false,
      title: 'Login Magic Link',
    },
  },
  {
    path: 'confirm-email',
    name: 'confirmEmail',
    component: () => import('@/views/auth/ConfirmEmail.vue'),
    meta: {
      bypassAuth: true,
      renderNav: false,
      title: 'Confirm Email',
    },
  },
];
